import { hasClosest } from '../../app/helpers'

const CSS = {
  ctn: 'sub-nav__parent',
  list: 'sub-nav',
  open: 'nav__item--open',
  title: 'nav__item__label--title',

  current: ['sub-nav__link--current', 'f500'],
}

export default class {
  constructor(isMobile) {
    this.items = document.getElementsByClassName(CSS.ctn)[0]

    if (!this.items) return
    this.list = this.items.getElementsByClassName(CSS.list)[0]
    this.title = this.items.getElementsByClassName(CSS.title)[0]

    this.current = document.getElementsByClassName(CSS.current[0])

    this.compute(isMobile, true)
  }

  close() {
    const wasOpen = !!this.isOpen

    this.toggle(false)

    return wasOpen
  }

  toggle(isOpen = !this.isOpen) {
    this.isOpen = isOpen

    if (isOpen) {
      this.items.classList.add(CSS.open)
    } else {
      this.items.classList.remove(CSS.open)
      this.title.blur()
    }

    this.list.style.maxHeight = this.isMobile && !isOpen ? 0 : this.maxHeight
  }

  updateCurrentNavItem(serviceName) {

    // Old service nav item.
    Array.from(this.current).forEach(prevItem => {
      CSS.current.forEach(className => prevItem.classList.remove(className))
    })

    // New service nav item.
    if (serviceName) {
      const serviceLink = this.list.querySelector(`[data-sub="${serviceName}"] a`)
      CSS.current.forEach(className => serviceLink.classList.add(className))
    }
  }

  onPageChange(path, link) {
    const splitPath = path.split('service/')
    const serviceName = splitPath.length === 2 ? splitPath[1] : null

    this.updateCurrentNavItem(serviceName)

    // Blur service nav item for focusin (probably not the best practice)
    if (serviceName && typeof(link) !== 'string') {
      link.blur()
      this.close()
    }
  }

  onTap(e) {

    // tap the sub navigation title
    if (hasClosest(e.target, `.${CSS.title}`)) {
      e.preventDefault()
      return this.toggle()
    }

    // tap in the list or outside the sub navigation
    if (this.isOpen && !hasClosest(e.target, `.${CSS.list}`)) {
      this.close()
    }
  }

  onResize(isMobile, closeMenu = false) {
    this.compute(isMobile, closeMenu)
  }

  compute(isMobile, closeMenu = false) {
    if (!this.list) return

    this.isMobile = isMobile
    this.maxHeight = isMobile
      ? this.list.firstElementChild.clientHeight + 'px'
      : 'none'

    if (closeMenu) {
      this.close()
    }
  }
}




// WEBPACK FOOTER //
// ./resources/js/modules/ServiceMenu/index.js